<template src="./OnePlusControlComponent.html"></template>
<script>
// import CommonService from "../../../services/common.service";
import SidebarComponent from '@/layouts/siderbars/sidebar-common/SidebarComponent.vue'
import HeaderComponent from '@/layouts/headers/header-common/HeaderComponent.vue'

export default {
  name: 'OnePlusControlComponent',
  components: { HeaderComponent, SidebarComponent },
  props: ['default'],
  data() {
    return {}
  },
  updated() {
    // this.$store.commit('clearAllErrorMessage');
    // CommonService.blurWindow();
  },
  mounted() {
    // if (!CommonService.getTokenAuth()) {
    //     this.$router.push("login");
    // }
  }
}
</script>
<style lang="scss">
  .layout-container {
    .layout-content {
      width: 100%;
    }
  }
</style>
